// extracted by mini-css-extract-plugin
export default {"certificateCard":"certifications_certificateCard__1n8Qf"};